import React, { useEffect, useRef, useState } from 'react';
import '../styles/common.css';
import './ComingSoon.css';

const SECRET = 'whoareyou?';
const STORAGE_KEY = 'koiro_unlocked';

/* minimal placeholder — just the mark and the copyright line.
   hidden unlock: triple-click the title to reveal the password field. */
function ComingSoon({ onUnlock }) {
  const [visible, setVisible] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [pw, setPw] = useState('');
  const [shake, setShake] = useState(false);
  const clickCount = useRef(0);
  const clickTimer = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (showInput) inputRef.current?.focus();
  }, [showInput]);

  const handleSecretClick = (e) => {
    e.stopPropagation();
    clickCount.current += 1;
    clearTimeout(clickTimer.current);
    if (clickCount.current >= 3) {
      clickCount.current = 0;
      setShowInput(true);
    } else {
      clickTimer.current = setTimeout(() => { clickCount.current = 0; }, 600);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pw === SECRET) {
      localStorage.setItem(STORAGE_KEY, '1');
      onUnlock();
    } else {
      setShake(true);
      setPw('');
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className={`cs-min-root${visible ? ' cs-min-root--in' : ''}`}>
      <div className="cs-min-mark" onClick={handleSecretClick}>
        <span className="cs-min-vol">Vol. 01 · 2026</span>
        <h1 className="cs-min-title">KOIRO</h1>
        <span className="cs-min-rule" />
        <p className="cs-min-tagline">Do I know you?</p>
      </div>

      <span className="cs-copyright">© 2026 KOIRO · all rights reserved · karma is working</span>

      {showInput && (
        <div className="cs-overlay" onClick={(e) => { e.stopPropagation(); setShowInput(false); setPw(''); }}>
          <form
            className={`cs-pw-form${shake ? ' cs-pw-form--shake' : ''}`}
            onClick={e => e.stopPropagation()}
            onSubmit={handleSubmit}
          >
            <input
              ref={inputRef}
              type="password"
              value={pw}
              onChange={e => setPw(e.target.value)}
              placeholder="—"
              className="cs-pw-input"
              autoComplete="off"
            />
          </form>
        </div>
      )}
    </div>
  );
}

export default ComingSoon;
